import { Suspense } from "react"
import { ChatCircle, Dot } from "@phosphor-icons/react"
import ChatTranscriptDrawer from "@/modules/patients/detail/progress-note/components/chat-transcript-drawer"
import { useDrawerStore } from "@/stores/useDrawerStore"

type ChatTranscriptProps = {
  patientId: string
  appointmentId: string
}

const ChatTranscriptContainer = (props: ChatTranscriptProps) => {
  const { appointmentId, patientId } = props

  const openDrawer = useDrawerStore((state) => state.openDrawer)

  const openChatTranscriptDrawer = () => {
    openDrawer(
      () => (
        <Suspense fallback={null}>
          <ChatTranscriptDrawer patientId={patientId} appointmentId={appointmentId} />
        </Suspense>
      ),
      "ChatTranscriptDrawer",
    )
  }

  return (
    <>
      <Dot className="relative -mx-3 -my-4 inline-block" size={36} />
      <ChatCircle className="text-primary relative bottom-0.5 mr-0.5 ml-0.5 inline-block" size={16} />
      <button className="inline-block cursor-pointer" onClick={openChatTranscriptDrawer}>
        App
      </button>
    </>
  )
}

export { ChatTranscriptContainer }
